import { createFeature, createReducer, on } from '@ngrx/store';
import { MapWallDisplayActions } from './map-wall-display.actions';
import { WallDisplayConfiguration, WidgetLocation } from '../models';

export enum WidgetFormType {
  Select = 0,
  Times = 1,
  Locations = 2,
  Image = 3,
  AlertsFeed = 4
}

export interface MapWallDisplayState {
  selectedLocationUId: string;
  configuration: WallDisplayConfiguration;
  isActive: boolean;
  widgetFormType: WidgetFormType;
}

const defaultState: MapWallDisplayState = {
  selectedLocationUId: undefined,
  isActive: false,
  configuration: undefined,
  widgetFormType: WidgetFormType.Select
};

const reducer = createReducer(
  defaultState,
  on(MapWallDisplayActions.showMapWallDisplay, (state, { stringifiedWallConfiguration }) => {
    const configuration: WallDisplayConfiguration = Boolean(stringifiedWallConfiguration)
      ? JSON.parse(stringifiedWallConfiguration)
      : undefined;

    return {
      ...state,
      isActive: true,
      configuration
    };
  }),
  on(MapWallDisplayActions.editMapWallDisplay, (state, { stringifiedWallConfiguration }) => {
    const configuration: WallDisplayConfiguration = Boolean(stringifiedWallConfiguration) ? JSON.parse(stringifiedWallConfiguration) : {};

    return {
      ...state,
      isActive: true,
      configuration
    };
  }),
  on(MapWallDisplayActions.hideMapWallDisplay, () => defaultState),
  on(MapWallDisplayActions.setConfiguration, (state, { configuration }) => ({ ...state, configuration })),
  on(MapWallDisplayActions.showTimesWidgetConfig, state => ({
    ...state,
    widgetFormType: WidgetFormType.Times
  })),
  on(MapWallDisplayActions.showLocationsWidgetConfig, state => ({
    ...state,
    widgetFormType: WidgetFormType.Locations
  })),
  on(MapWallDisplayActions.showImageWidgetConfig, state => ({
    ...state,
    widgetFormType: WidgetFormType.Image
  })),
  on(MapWallDisplayActions.showAlertsFeedWidgetConfig, state => ({
    ...state,
    widgetFormType: WidgetFormType.AlertsFeed
  })),
  on(MapWallDisplayActions.hideWidgetConfig, state => ({
    ...state,
    widgetFormType: WidgetFormType.Select
  }))
);

export const MapWallDisplayFeature = createFeature({
  name: 'mapWallDisplay',
  reducer
});
